import { useTooltip_unstable } from './useTooltip';
import { renderTooltip_unstable } from './renderTooltip';
import { useTooltipStyles_unstable } from './useTooltipStyles';
/**
 * A tooltip provides light weight contextual information on top of its target element.
 */

export const Tooltip = props => {
  const state = useTooltip_unstable(props);
  useTooltipStyles_unstable(state);
  return renderTooltip_unstable(state);
};
Tooltip.displayName = 'Tooltip'; // type casting here is required to ensure internal type FluentTriggerComponent is not leaked

Tooltip.isFluentTriggerComponent = true;
//# sourceMappingURL=Tooltip.js.map